/*
Wiki: https://dev.azure.com/Reaktor-LynkCo/Brand-Sitecore-JSS/_wiki/wikis/Brand-Sitecore-JSS.wiki/270/Phone-number-formatting
*/

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { Input } from "..";
import { isValidPhoneArea, isValidPhone } from "../../utils/validations";
import classNames from "classnames";
export default function InputPhoneNumber({ phoneArea, phoneNumber, infoMessage = "", missingMessage = "", warningMessage = "[WARNING_MESSAGE]", onChange, onInit, submitTimestamp }) {
  const [errorMessage, setErrorMessage] = useState("");
  const [area, setArea] = useState({ value: phoneArea?.value, valid: phoneArea?.value ? isValidPhoneArea(phoneArea?.value) : undefined });
  const [number, setNumber] = useState({ value: phoneNumber?.value, valid: phoneNumber?.value ? isValidPhone(phoneNumber?.value) : undefined });
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const onChangeArea = (event, isValid) => {
    isValid = !event.target.value && missingMessage ? false : isValid;
    setArea({ valid: missingMessage && !event.target.value ? false : isValid, value: event.target.value });
    typeof onChange === "function" && onChange(event.target.value, number.value, isValid && number.valid ? true : false);
  };

  const onChangeNumber = (event, isValid) => {
    isValid = !event.target.value && missingMessage ? false : isValid;
    setNumber({ valid: missingMessage && !event.target.value ? false : isValid, value: event.target.value });
    typeof onChange === "function" && onChange(area.value, event.target.value, isValid && area.valid ? true : false);
  };

  const onBlurArea = (event, isValid) => {
    (!number.valid || !area.valid) && setShowErrorMessage(true);
    typeof phoneArea?.onBlur === "function" && phoneArea.onBlur(event, isValid);
  };

  const onBlurNumber = (event, isValid) => {
    (!number.valid || !area.valid) && setShowErrorMessage(true);
    typeof phoneNumber?.onBlur === "function" && phoneNumber.onBlur(event, isValid);
  };

  const onFocusNumber = event => {
    typeof phoneNumber?.onFocus === "function" && phoneNumber.onFocus(event);
  };

  const onFocusAreaCode = event => {
    typeof phoneArea?.onFocus === "function" && phoneArea.onFocus(event);
  };

  const getErrorMessage = () => {
    if (area.value && area.valid && !number.value) return missingMessage;
    if (area.value && area.valid && number.value && !number.valid) return warningMessage;
    if (area.value && !area.valid && number.value && !number.valid) return warningMessage;
    if (area.value && !area.valid && number.value && number.valid) return warningMessage;
    if (area.value && !area.valid && !number.value) return missingMessage;
    if (!area.value && number.value && number.valid) return missingMessage;
    if (!area.value && !number.value) return missingMessage;
    if (!area.value && number.value && !number.valid) return missingMessage;
  };

  const isPhoneValid = () => {
    return missingMessage ? area.valid === true && number.valid === true : (!area.value && !number.value) || (area.valid === true && number.valid === true);
  };

  useEffect(() => {
    typeof onInit === "function" && onInit(area.value, number.value, isPhoneValid());
  }, []);

  useEffect(() => {
    const error = getErrorMessage();
    setErrorMessage(error);
  }, [area, number]);

  useEffect(() => {
    submitTimestamp && !isPhoneValid() && setShowErrorMessage(true);
  }, [submitTimestamp]);

  const wrapperClasses = classNames("phone-container", {
    "with-error": errorMessage && showErrorMessage,
    "with-info": infoMessage
  });
  const errorClasses = classNames("phone-error-message", {
    "with-error": errorMessage && showErrorMessage
  });
  return (
    <>
      <div className={wrapperClasses}>
        <Input
          {...{
            // ...phoneArea,
            value: phoneArea?.value,
            label: phoneArea?.label,
            className: "tel-area",
            name: "tel-area",
            autocomplete: "tel-local",
            type: "tel-area",
            showError: area.valid === false || (!area.valid && submitTimestamp),
            onChange: onChangeArea,
            onFocus: onFocusAreaCode,
            onBlur: onBlurArea,
            submitTimestamp: submitTimestamp
          }}
        />
        <Input
          {...{
            // ...phoneNumber,
            value: phoneNumber?.value,
            label: phoneNumber?.label,
            className: "tel",
            name: "tel-local",
            autocomplete: "tel-phonenumber",
            type: "tel",
            showError: number.valid === false || (!number.valid && submitTimestamp),
            onChange: onChangeNumber,
            onFocus: onFocusNumber,
            onBlur: onBlurNumber,
            submitTimestamp: submitTimestamp
          }}
        ></Input>
      </div>
      {infoMessage && <div className="info-message">{infoMessage}</div>}
      {showErrorMessage && <div className={errorClasses}>{errorMessage}</div>}
    </>
  );
}
InputPhoneNumber.propTypes = {
  phoneArea: PropTypes.object,
  phoneNumber: PropTypes.object
};
